var animarGaleria = {};
var animarBanner = {};

Boss.ux = {
	getTransitionEvent: function(){
		var t;
		var el = document.createElement('fakeelement');
		var transitions = {
			'transition':'transitionend',
			'OTransition':'oTransitionEnd',
			'MozTransition':'transitionend',
			'WebkitTransition':'webkitTransitionEnd'
		}

		for(t in transitions){
			if(el.style[t] !== undefined){
				return transitions[t];
			}
		}
	},
	tooltip: function(evts){

		if(!window.lasttooltip){
			window.lasttooltip = '';
		}
		if(!window.tooltips){
			window.tooltips = {};
		}

		var screensizes = Boss.screensizes();

		var el = Boss.targt(evts);
		if(el !== window && el !== null && el.getAttribute('data-title') === null && el.parentElement !== null && el.parentElement.getAttribute('data-title') !== null){
			el = el.parentElement;
		}
		if(el !== window && el !== null && el.getAttribute('data-title') !== null){

			if(Boss.getById(el.getAttribute('data-title'))){

				var atual = el.getAttribute('data-title');

				var tip = Boss.getById(atual);

				var rect = el.getBoundingClientRect();

				var top = (rect.top - tip.clientHeight - 10).toFixed(0);
				var left = (rect.left+(rect.width / 2)-(tip.clientWidth / 2)).toFixed(0);

				var colisionRight = (rect.left+(rect.width / 2) + tip.clientWidth).toFixed(0);
				if(colisionRight > screensizes.viewWidth){
					left = (screensizes.viewWidth - 40 - tip.clientWidth).toFixed(0);
				}

				if(tip.getAttribute('data-apply') == null){

					tooltips[atual] = atual;
					lasttooltip = atual;

					tip.style.top = top+'px';
					tip.style.left = left+'px';

					tip.setAttribute('data-apply', 'true');
					tip.classList.add('boss-tooltip-active');
				}
			}
		}else{
			lasttooltip = '';
		}

		/* REMOVE */
		for(var x in tooltips){
			if(x != lasttooltip){
				if(Boss.getById(x)){
					var tt = Boss.getById(x);
					tt.removeAttribute('data-apply');
					tt.classList.remove('boss-tooltip-active');
					delete tooltips[x];
				}
			}
		}
	},
	toggle: {
		render: function(){

			for(var idtoggle in sessionStorage){

				if(Boss.getById(idtoggle)){

					var toggle = Boss.getById(idtoggle);
					if(sessionStorage.getItem(idtoggle) === 'true'){

						toggle.style.display = '';
						if(Boss.getById(idtoggle+'icon')){
							var toggleicon = Boss.getById(idtoggle+'icon');
							toggleicon.classList.add('fa-chevron-up');
							toggleicon.classList.remove('fa-chevron-down');

						}

					}else if(sessionStorage.getItem(idtoggle) === 'false'){

						toggle.style.display = 'none';
						if(Boss.getById(idtoggle+'icon')){
							var toggleicon = Boss.getById(idtoggle+'icon');
							toggleicon.classList.remove('fa-chevron-up');
							toggleicon.classList.add('fa-chevron-down');
						}
					}
				}
			}
		},
		init: function(evts){
			var el = Boss.targt(evts);
			if(!el.getAttribute('data-toggle')){
				while(el !== null){
					el = el.parentElement;
					if(el !== null && el.getAttribute('data-toggle')){
						break;
					}
					if(el === null){
						break;
					}
				}
			}

			if(el !== null && el.getAttribute('data-toggle')){

				var idtoggle = el.getAttribute('data-toggle');
				var icon = el.getAttribute('data-icon');

				if(Boss.getById(idtoggle)){

					if(sessionStorage.getItem(idtoggle) === null){
						sessionStorage.setItem(idtoggle, 'false');
					}else{

						if(sessionStorage.getItem(idtoggle) === 'true'){
							sessionStorage.setItem(idtoggle, 'false');
						}else if(sessionStorage.getItem(idtoggle) === 'false'){
							sessionStorage.setItem(idtoggle, 'true');
						}
					}

					this.render();
				}
			}
		}
	},
	bigImage: {
		init: function(img, label){

			var mask = '<div id="boss-bigimage-close" class="boss-bigimage-close">+</div><div class="boss-bigimage-label">'+label+'</div><img alt="imagem" src="'+img+'" />';

			if(Boss.getById('boss-bigimage')){
				var div = Boss.getById('boss-bigimage');
				div.innerHTML = mask;
			}else{
				var div = document.createElement('div');
				div.setAttribute('id', 'boss-bigimage');
				div.classList.add('boss-bigimage');
				div.innerHTML = mask;
				document.body.appendChild(div);
			}

			var screensizes = Boss.screensizes();
			var alt = screensizes.viewHeight;

			div.classList.remove('hidden');
			div.style.height = alt+'px';

			Boss.evts.add(Boss.evtTouchUp(), div, function(evt){
				var el = Boss.targt(evt);
				if(el.classList.contains('boss-bigimage')){
					el.classList.add('hidden');
				}
			});

			Boss.evts.add(Boss.evtTouchUp(), Boss.getById('boss-bigimage-close'), function(evt){
				var el = Boss.getById('boss-bigimage');
				el.classList.add('hidden');
			});
		}
	},
	blurup: function(){

		var imgs = document.querySelectorAll('img');
		var timgs = imgs.length;

		var backgrounds = document.querySelectorAll('[data-src-background]');
		var tbackgrounds = backgrounds.length;

		for(var x = 0; x < timgs; x++){
			var ig = imgs[x];

			/* IMG TAG */
			if(ig.getAttribute('data-src')){
				var sr = ig.getAttribute('data-src');
				var id = 'blur-up'+(Math.random()*1000000).toFixed(0);

				if(ig.getAttribute('id')){
					id = ig.getAttribute('id');
				}else{
					ig.setAttribute('id', id);
				}

				var i = new Image();
				i.setAttribute('data-blurupto', id);
				i.setAttribute('src', sr);
				i.onload = function(){

					if(this.getAttribute('data-blurupto') && this.getAttribute('src')){
						if(Boss.getById(this.getAttribute('data-blurupto'))){
							Boss.getById(this.getAttribute('data-blurupto')).setAttribute('src', this.getAttribute('src'));
							Boss.getById(this.getAttribute('data-blurupto')).classList.remove('blur-up');
						}
					}
				}
			}
		}

		for(var x = 0; x < tbackgrounds; x++){
			var ig = backgrounds[x];

			/* IMG BACKGROUND */
			if(ig.getAttribute('data-src-background')){

				var sr = ig.getAttribute('data-src-background');
				var id = 'blur-up'+(Math.random()*1000000).toFixed(0);

				if(ig.getAttribute('id')){
					id = ig.getAttribute('id');
				}else{
					ig.setAttribute('id', id);
				}

				var i = new Image();
				i.setAttribute('data-blurupto', id);
				i.setAttribute('src', sr);
				i.onload = function(){

					if(this.getAttribute('data-blurupto') && this.getAttribute('src')){
						if(Boss.getById(this.getAttribute('data-blurupto'))){
							Boss.getById(this.getAttribute('data-blurupto')).style.backgroundImage = 'url('+this.getAttribute('src')+')';
						}
					}
				}
			}
		}
	},/*
	isElementVisible: function(el){

		if(el != null){
			var rect 	= el.getBoundingClientRect();
			var vWidth	= window.innerWidth || doc.documentElement.clientWidth;
			var vHeight	= window.innerHeight || doc.documentElement.clientHeight;
			var efp 	= function (x, y){
				return document.elementFromPoint(x, y)
			};

			if(rect.right < 0 || rect.bottom < 0 || rect.left > vWidth || rect.top > vHeight){
			    return false;
			}

			return (el.contains(efp(rect.left,  rect.top)) ||  el.contains(efp(rect.right, rect.top)) ||  el.contains(efp(rect.right, rect.bottom)) ||  el.contains(efp(rect.left,  rect.bottom)));
		}
	},*/
	autoClip: function(id){
		if(Boss.getById(id)){
			Boss.evts.add(Boss.evtTouchUp(), Boss.getById(id), function(evts){
				var el = Boss.targt(evts);
				if(el.classList.contains('boss-auto-clipboard')){
					Boss.ux.clip(el);
					el.classList.add('boss-auto-clipboard-sucess');
					Boss.delay(function(){
						el.classList.remove('boss-auto-clipboard-sucess');
					}, 2000);
				}
			});
		}
	},
	clip: function(el){
		var tx = document.createElement('textarea');
		tx.textContent = el.innerText.replace(/\s+$/, '').replace(/^\s+/, '');
		if(el.getAttribute('data-tab')){
			tx.textContent = tx.innerText.split('    ').join("\t");
		}
		tx.focus();
		tx.classList.add('hidden');
		tx.style.width = '1px';
		tx.style.height = '1px';
		el.appendChild(tx);
		tx.select();
		document.execCommand('copy');
		Boss.delay(function(){
			Boss.remover(tx);
		}, 10);
	},
	textarea: {
		mem: {},
		heightTextarea: function(id){

			if(Boss.getById(id)){
				
				var min = false;
				var max = false;
				var el = Boss.getById(id);

				if(typeof(Boss.ux.textarea.mem[id].min) !== 'undefined' && Boss.ux.textarea.mem[id].min > 0){
					min = Boss.ux.textarea.mem[id].min;
				}
				if(typeof(Boss.ux.textarea.mem[id].max) !== 'undefined' && Boss.ux.textarea.mem[id].max > 0){
					max = Boss.ux.textarea.mem[id].max;
				}

				el.style.overflow = 'hidden';
				el.style.height = 'auto';

				if(min !== false){
					el.style.minHeight = min+'px';
				}

				if(max !== false && el.scrollHeight <= max){
					el.style.height = el.scrollHeight+'px';
				}else{
					el.style.height = max+'px';
					el.style.overflow = 'auto';
				}
			}
		},
		height: function(id, obj){

			if(Boss.getById(id)){

				if(typeof(obj) !== 'object'){
					obj = {};
				}

				var el = Boss.getById(id);

				Boss.ux.textarea.mem[id] = obj;
				Boss.ux.textarea.heightTextarea(id);

				Boss.evts.add('keyup', el, function(evt){
					Boss.ux.textarea.heightTextarea(id);
				});

				Boss.evts.add('mouseup', el, function(evt){
					Boss.ux.textarea.heightTextarea(id);
				});

				Boss.evts.add('paste', el, function(evt){
					Boss.ux.textarea.heightTextarea(id);
				});

				Boss.evts.add('cut', el, function(evt){
					Boss.ux.textarea.heightTextarea(id);
				});
			}
		}
	},
	maximizeImg: function(evts){

		var im = Boss.targt(evts);
		if(im.nodeName === 'IMG' && im.getAttribute('data-maximizeImg')){

			var pos = Boss.targt(evts).getBoundingClientRect();

			var img = document.createElement('img');
			img.setAttribute('src', im.getAttribute('src'));
			img.setAttribute('alt', im.getAttribute('alt'));

			if(Boss.getById('ux-maximizeimg')){

				var div = Boss.getById('ux-maximizeimg');
				div.innerHTML = '';
				div.appendChild(img);
				div.style.top = pos.top+'px';
				div.style.left = pos.left+'px';
				div.style.transform = 'translateX(0%) translateY(0%)';
				div.style.maxWidth = im.clientWidth+'px';
				div.style.maxHeight = im.clientHeight+'px';
				Boss.delay(function(){
					div.classList.add('ux-maximizeimg');
				}, 260);

			}else{

				var bmio = document.createElement('div');
				Boss.getById('content').appendChild(bmio);
				bmio.setAttribute('id', 'ux-maximizeimgoverlay');

				var div = document.createElement('div');
				Boss.getById('content').appendChild(div);
				div.setAttribute('id', 'ux-maximizeimg');

				div.style.top = pos.top+'px';
				div.style.left = pos.left+'px';
				div.style.transform = 'translateX(0%) translateY(0%)';
				div.style.maxWidth = im.clientWidth+'px';
				div.style.maxHeight = im.clientHeight+'px';
				div.appendChild(img);
				Boss.delay(function(){
					bmio.classList.add('ux-maximizeimgoverlay');
					div.classList.add('ux-maximizeimg');
				}, 1);

				Boss.evts.add(Boss.evtTouchUp(), Boss.getById('ux-maximizeimg'), function(evts){
					var div = Boss.getById('ux-maximizeimg').classList.remove('ux-maximizeimg');
					var bmio = Boss.getById('ux-maximizeimgoverlay').classList.remove('ux-maximizeimgoverlay');
				});

				Boss.evts.add(Boss.evtTouchUp(), Boss.getById('ux-maximizeimgoverlay'), function(evts){
					var div = Boss.getById('ux-maximizeimg').classList.remove('ux-maximizeimg');
					var bmio = Boss.getById('ux-maximizeimgoverlay').classList.remove('ux-maximizeimgoverlay');
				});

				Boss.evts.add(Boss.ux.getTransitionEvent(), Boss.getById('ux-maximizeimgoverlay'), function(evts){
					if(Boss.getById('ux-maximizeimgoverlay') && Boss.getById('ux-maximizeimgoverlay').classList.contains('ux-maximizeimgoverlay') === false){
						Boss.remover(Boss.getById('ux-maximizeimgoverlay'));
					}
				});

				Boss.evts.add(Boss.ux.getTransitionEvent(), Boss.getById('ux-maximizeimg'), function(evts){
					if(Boss.getById('ux-maximizeimg') && Boss.getById('ux-maximizeimg').classList.contains('ux-maximizeimg') === false){
						Boss.remover(Boss.getById('ux-maximizeimg'));
					}
				});
			}
		}
	},
	clock: function(el){

		if(el !== null){

			var tempo = new Date();

			var dia = tempo.getDate();
			var mes = (tempo.getMonth() + 1);
			var ano = tempo.getFullYear();
			var horas = tempo.getHours();
			var minutos = tempo.getMinutes ();
			var segundos = tempo.getSeconds ();

			dia = (dia < 10 ? '0' : '' ) + dia;
			mes = (mes < 10 ? '0' : '' ) + mes;
			horas = (horas < 10 ? '0' : '') + horas;
			minutos = (minutos < 10 ? '0' : '') + minutos;
			segundos = (segundos < 10 ? '0' : '') + segundos;

			el.innerHTML = dia+'/'+mes+'/'+ano+'&nbsp;'+horas +'<span>:</span>'+minutos+'<span>:</span>'+segundos;
			Boss.delay(function(){
				Boss.ux.clock(el);
			}, 500);

		}
	}
};

Boss.evts.add('click', document, function(evts){
	Boss.ux.toggle.init(evts);
});

Boss.evts.add('mousemove', document, function(evts){
	Boss.ux.tooltip(evts);
});

Boss.evts.add('fakescroll', window, function(evts){
	Boss.ux.tooltip(evts);
});